<template>
  <div class="col_2 w934 onsite_b task_jihua_list">
    <v-dialog />
    <h5 class="none_ts" v-if="cntData <= 0 || !lists" style="text-align: center;">
      <img src="@/assets/images/none_data.jpg" alt="">
      <h4>暂无问卷</h4>
    </h5>
    <dl v-for="item in lists" :key="item.id">
      <dt>
        <span class="btn_end" v-if="item.examIdFinish">已完成</span>
        <img src="@/assets/images/course_default.png" v-if="!item.faceUri || item.faceUri == ''" />
        <img :src="item.faceUri" v-if="item.faceUri && item.faceUri !== ''">
      </dt>
      <dd class="narrow">
        <h3>{{item.title}}</h3>
        <p>题目数量：{{item.cntQuestion}}题</p>
        <p>开放时间： {{ dateFormat(new Date(item.startDate), 'yyyy-MM-dd hh:mm:ss') }} 至 {{ dateFormat(new Date(item.endDate), 'yyyy-MM-dd hh:mm:ss') }}</p>
        <p class="num_man">{{item.isUsed}}人次参与</p>
        <p>可否重复回答: {{item.canDuplication == '1' ? '可以': '不可以'}}</p>
        <a class="a_detail" v-if="item.canDuplication == '1' || (item.canDuplication == '0' && !item.examIdFinish)" @click="doQuestionnaire(item, '0')" style="cursor: pointer; top: 55px;">回答问卷</a>
        <a href="javascript:;" style="top: 105px; cursor: pointer;" class="a_detail" @click="checkResult(item, '0')" v-if="item.examIdFinish && item.examIdFinish!=''">问卷答案</a>
      </dd>
    </dl>
  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
  import utils from '@/utils'
  import { getCookie } from '@/store/cookies.js'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [],
        filters: {
          pageNo: 1,
          pageSize: 12,
          itemType: '02'
        },
        pages: 0,
        cntData: '',
        examPaperInfo: {}
      }
    },
    created () {
      this.search(this.filters)
    },
    methods: {
      dateFormat: utils.dateFormat,
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      search (filters) {
        api.post(config.bylApiPath, '/studyItemPermissions/myTasks', filters, (r) => {
          this.lists = r.data
          this.cntData = r.cntData // 总数
          this.pages = Math.ceil(r.cntData / this.filters.pageSize) // 页数
        })
      },
      checkResult (item, type) {
        var path = getCookie('org') ? this.$OR.getUrl(getCookie('org').businessId) : ''
        this.$router.push({path: path + '/questionnaireResult/' + item.examIdFinish + '/' + type})
      },
      doQuestionnaire (item, type) {
        if (getCookie(process.env.TOKEN_KEY)) {
          this.$api.post(this.$global.examApiPath, '/examPaper/searchByUser', {id: item.id}, r => { // 生成examId
            if (r.data) {
              this.examPaperInfo = r.data[0]
              this.startQuestionnaire(this.examPaperInfo, type)
            }
          })
        } else {
          this.$toasted.show('请先登录')
        }
      },
      startQuestionnaire (examPaperInfo, type) {
        var path = getCookie('org') ? this.$OR.getUrl(getCookie('org').businessId) : ''
        if (getCookie(process.env.TOKEN_KEY) && getCookie(process.env.TOKEN_KEY) != '') {
          let state = this.$utils.judgmentState(examPaperInfo.startDate, examPaperInfo.endDate)
          if (state=='0') {
            let that = this
            if (!examPaperInfo.examIdFinish) { // 该问卷没有完成过
              if (examPaperInfo.examId && examPaperInfo.examId!='') { // 继续做
                that.$router.push({path: path + '/questionnaireStart/' + examPaperInfo.examId + '/' + type + '/' + examPaperInfo.id})
              } else { // 完全的重新做
                that.$api.post(that.$global.examApiPath, '/examExamScore/getExamId', {paperId: examPaperInfo.id}, r => {
                  if (r.data) {
                    that.$router.push({path: path + '/questionnaireStart/' + r.data + '/' + type + '/' + examPaperInfo.id})
                  }
                })
              }
            } else { //  该问卷已完成过
              if (examPaperInfo.canDuplication == '1') {
                that.$api.post(that.$global.examApiPath, '/examExamScore/getExamId', {paperId: examPaperInfo.id}, r => {
                  if (r.data) {
                    that.$router.push({path: path + '/questionnaireStart/' + r.data + '/' + type + '/' + examPaperInfo.id})
                  }
                })
              } else {
                console.log('不允许再答了')
              }
            }
          } else if (state=='1') {
            this.$toasted.show('该问卷已结束', {
              duration: 1000
            })
          } else if (state=='2') {
            this.$toasted.show('该问卷未开放', {
              duration: 1000
            })
          } else if (state=='-1') {
            this.$toasted.show('该问卷开始时间或结束时间有误', {
              duration: 1000
            })
          }
        } else {
          this.$toasted.show('请先登录！', {
            duration: 800
          })
        }
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/modules/task/myQTest.vue